import request from 'umi-request';
import type { PanicRequest } from '../model/panicRequest';
import { environment } from './../../environment/environment';
import type { ApiResponse } from '../model/apiResponse';

//List products
export async function GetProducts(token: string, clientId?: string | null): Promise<ApiResponse> {
  return await request('/products/pwa/client', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: '?clientId=' + clientId,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function GetProductsWithPolicyWording(token: string, clientId?: string | null): Promise<ApiResponse> {
  return await request('/products/productspolicywording/pwa/client', {
    method: 'GET',
    prefix: environment.baseUrl,
    suffix: '?clientId=' + clientId,
    requestType: "json",
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  })
    .then(function (response: ApiResponse) {
      return response
    })
    .catch(function (errorResponse) {
      return errorResponse.data
    });
}

export async function sendPanicRequest(panic: PanicRequest, token: string): Promise<ApiResponse> {
  return request(`/panic`, {
    method: "POST",
    prefix: environment.baseUrl,
    headers: {
      Accept: "*/*",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    data: panic, // IMPORTANT: send our Panic object
    requestType: "json",
  })
    .then((res: ApiResponse) => res)
    .catch((err) => err?.data);
}